import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { AppTooltipComponent } from './tooltip.component';
import { TooltipInnerComponent } from './tooltip-inner/tooltip-inner.component';
import { TruncateWithTooltipComponent } from 'shared/tooltip/truncate-with-tooltip/truncate-with-tooltip.component';


@NgModule({
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
  ],
  declarations: [
    AppTooltipComponent,
    TooltipInnerComponent,
    TruncateWithTooltipComponent
  ],
  exports: [
    AppTooltipComponent,
    TooltipInnerComponent,
    TruncateWithTooltipComponent
   ],
  providers: []
})
export class AppTooltipModule {}
